module.exports = __webpack_public_path__ + "img/img_kapian.75bdd1c4.png";